
        var result = require("!!../../../../node_modules/css-loader/index.js!./curecredit.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/curecredit.component.css
// module id = 2355
// module chunks = 1